<template>
  <div class="state-container">
    <v-progress-circular v-if="isLoading" indeterminate color="primary" />
    <span v-else-if="showNoData">{{ $t("message.common.noData") }}</span>
  </div>
</template>

<script>
export default {
  name: "ReviewsCategoriesHeatmapStateContainer",
  props: {
    isLoading: {
      type: Boolean,
      default: false
    },
    showNoData: {
      type: Boolean,
      default: false
    }
  }
};
</script>
<style lang="scss" scoped>
.state-container {
  width: 100%;
  height: 276px;
  display: flex;
  justify-content: center;
  align-items: center;
  background: rgba(0, 0, 0, 0.05);
  border-radius: 25px;
  margin: 0 auto $spacing * 2.5 auto;
}
</style>
